<router-outlet></router-outlet>
<!-- <app-global-spinner *ngIf="sharedService.spinner$ | async"></app-global-spinner> -->